import React from 'react';
import classes from './DropDown.module.css';

type Props = {
  onClose: () => void;
  isOpen: boolean;
  Toggle: () => React.ReactElement;
  children: React.ReactNode;
};
const DropDown: React.FC<Props> = ({ onClose, isOpen, Toggle, children }) => {
  return (
    <div className={classes.container}>
      <Toggle />
      {isOpen && <div className={classes.backdrop} onClick={onClose} />}
      <div className={`${isOpen ? classes.dropDownMenu : classes.hiddenDropDown}`}>
        <div className={classes.menuContainer}>{children}</div>
      </div>
    </div>
  );
};

export { DropDown };
